import { gql } from "@apollo/client";

export default gql`
  mutation removePositionByPrivateJobRecurringId($data: RemovePositionByPrivateJobRecurringIdInput!) {
    removePositionByPrivateJobRecurringId(data: $data)
  }
`;
